module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_1_2.192430e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_1_2.png
// module id = D89q
// module chunks = 34